// useHelpContext.js

import { useDatabase } from 'context/DatabaseContext';
import { useNavigation } from 'context/NavigationContext';
import { useNodeTypes } from 'context/NodeTypesContext';
import { resolveHelpContextTypeKey } from 'utilities/HelpArticles';

/**
 * Resolves the current help reader context from the open node or collection.
 *
 * @returns {{ typeKey: string, typeLabel: string }}
 */
export default function useHelpContext() {
  const { currentNode } = useNavigation();
  const { activeDatabase } = useDatabase();
  const { getLabel } = useNodeTypes();

  const typeKey = resolveHelpContextTypeKey(currentNode, activeDatabase);
  const typeLabel = typeKey ? (getLabel(typeKey) || typeKey) : '';

  return {
    typeKey,
    typeLabel,
  };
}
